<script setup>
import { format, parseISO } from "date-fns";

const { data: webinars } = useNuxtData("previous-webinars");

const showVideo = ref(false);
const selectedWebinar = ref(null);

const toast = useToast();

const openVideo = (webinar) => {
  if (!webinar?.video_url || webinar?.video_url === "") {
    toast.add({
      severity: "warn",
      summary: "Video not available",
      detail: "This webinar does not have a video yet.",
      life: 3000,
    })
    return;
  }
  selectedWebinar.value = webinar;
  showVideo.value = true;
};

const formatDate = (dateTime) => {
  if (!dateTime) return;
  const date = parseISO(dateTime);

  const formattedDate = format(date, "dd MMM, yyyy");
  const formattedTime = format(date, "h:mma");

  return `${formattedDate} • ${formattedTime}`;
};
</script>

<template>
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
    <div v-for="webinar in webinars" :key="webinar.id" 
      class="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow">
      <div class="relative">
        <img 
          v-if="webinar?.media?.length > 0"
          :src="webinar?.media?.at(0)?.original_url" 
          :alt="webinar.title"
          class="w-full aspect-video object-cover opacity-80"
        />
        <img
          v-else
          src="~/assets/img/webinar-dummy.jpg"
          alt="dummy"
          class="w-full aspect-video object-cover opacity-80"
        />
        <Button
          icon="pi pi-play"
          rounded
          class="!absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
          @click="openVideo(webinar)"
        />
      </div>
      <div class="p-4 space-y-2">
        <h3 class="font-semibold text-surface-900 line-clamp-2">{{ webinar.title }}</h3>
        <div class="flex items-center gap-2 text-surface-600 text-sm">
          <i class="pi pi-calendar"></i>
          <span>{{ formatDate(webinar.start_time) }}</span>
          <!-- <i class="pi pi-clock ml-2"></i>
          <span>{{ webinar.duration }} mins long</span> -->
        </div>
      </div>
    </div>
  </div>

  <!-- Video Dialog -->
  <Dialog 
    v-model:visible="showVideo"
    modal
    :style="{ width: '80vw' }"
    :closable="true"
    :closeOnEscape="true"
    :pt="{
      root: 'bg-black',
      content: 'p-0',
      header: 'flex justify-end p-4'
    }"
  >
    <div class="aspect-video w-full">
      <iframe
        v-if="selectedWebinar?.video_url"
        :src="selectedWebinar.video_url"
        class="w-full h-full"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
  </Dialog>
</template>
